import { render, staticRenderFns } from "./MyTree.vue?vue&type=template&id=1b450d8f&scoped=true"
import script from "./MyTree.vue?vue&type=script&lang=js"
export * from "./MyTree.vue?vue&type=script&lang=js"
import style0 from "./MyTree.vue?vue&type=style&index=0&id=1b450d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b450d8f",
  null
  
)

export default component.exports